<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('service-over-view')" v-if="permissionCodes.indexOf('018006000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('service-category-manage')" v-if="permissionCodes.indexOf('018001000') !== -1">
        <i class="el-icon-damai-leimupinleifenleileibie"></i>
        <span slot="title">服务类目</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('service-provider-manage')" v-if="permissionCodes.indexOf('018002000') !== -1">
        <i class="el-icon-damai-Group" style="font-size: 20px;"></i>
        <span slot="title">服务商管理</span>
      </el-menu-item>
      <!--<el-menu-item index="4" @click="toNewRouter('invoice-config')" >-->
        <!--<i class="el-icon-damai-fapiao2"></i>-->
        <!--<span slot="title">收款账户</span>-->
      <!--</el-menu-item>-->
      <el-menu-item index="5" @click="toNewRouter('service-venue-record')" v-if="permissionCodes.indexOf('018003000') !== -1">
        <i class="el-icon-damai-zhuanjiayuyue"></i>
        <span slot="title">预约记录</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('service-consumption-record')" v-if="permissionCodes.indexOf('018004000') !== -1">
        <i class="el-icon-damai-zhangdan"></i>
        <span slot="title">收费明细</span>
      </el-menu-item>
      <el-menu-item index="7" @click="toNewRouter('value-added-log')" v-if="permissionCodes.indexOf('018005000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>
      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: "service-over-view",
  2: [
    "service-category-manage",
    "service-category-add",
    "service-category-modify",
  ],
  3: [
    "service-provider-manage",
    "service-provider-add",
    "service-provider-modify",
  ],
  4: [
    "invoice-tax-rate-manage",
    "invoice-tax-rate-add",
    "invoice-tax-rate-modify",
  ],
  5: "service-venue-record",
  6: "service-consumption-record",
  7: "value-added-log",
});

export default {
  name: "epidemic-situation-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/ValueAddedService/ValueAddedNav.vue